import React, { useEffect } from 'react';

const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.blurr.voice';

function Download() {
  useEffect(() => {
    window.location.replace(playStoreUrl);
  }, []);

  return (
    <div className="download-page">
      <div className="download-container">
        <p className="step-text">Get Panda on the Play Store.</p>
        <a
          href={playStoreUrl}
          className="clip-btn clip-btn-accent"
          rel="noopener noreferrer"
        >
          GET ON PLAY STORE
        </a>
      </div>
    </div>
  );
}

export default Download;
